import cx from "classnames";
import Image from "@/components/Image";
import Styles from "./TeamPlayerAvatar.module.scss";

type TeamPlayerAvatarProps = {
  containerClassName?: string;
  primaryImgName: string;
  primaryImgUrl?: string | null;
  primaryImgSize: number;
  primaryImgClassName?: string;
  secondaryImgName?: string;
  secondaryImgUrl?: string | null;
  secondaryImgSize?: number;
};

const TeamPlayerAvatar = ({
  containerClassName,
  primaryImgName,
  primaryImgUrl,
  primaryImgSize,
  primaryImgClassName,
  secondaryImgName,
  secondaryImgUrl,
  secondaryImgSize = 18,
}: TeamPlayerAvatarProps) => {
  const containerClasses = cx(Styles.container, containerClassName);
  const primaryImgClasses = cx(Styles.avatar, primaryImgClassName);

  return (
    <div
      className={containerClasses}
      style={{
        minWidth: primaryImgSize,
      }}
    >
      <Image
        fallback="/research/images/personPlaceholder.svg"
        className={primaryImgClasses}
        style={{
          width: primaryImgSize,
          height: primaryImgSize,
        }}
        alt={primaryImgName}
        src={primaryImgUrl}
        width={primaryImgSize}
        height={primaryImgSize}
      />
      {secondaryImgName && secondaryImgUrl ? (
        <div
          className={Styles.teamImageContainer}
          style={{
            position: "absolute",
            top: secondaryImgSize,
            left: secondaryImgSize * 1.4,
            width: secondaryImgSize,
            height: secondaryImgSize,
          }}
        >
          <Image
            fallback="/research/images/personPlaceholder.svg"
            style={{
              width: secondaryImgSize,
              height: secondaryImgSize,
              padding: "4px",
            }}
            alt={secondaryImgName}
            src={secondaryImgUrl}
            width={secondaryImgSize}
            height={secondaryImgSize}
          />
        </div>
      ) : null}
    </div>
  );
};

export default TeamPlayerAvatar;
